import React, { useState } from 'react';
import Header from './components/Header';
import UploadSection from './components/UploadSection';
import ErrorAlert from './components/ErrorAlert';
import ResultsSection from './components/ResultsSection';
import Footer from './components/Footer';
import './App.css';

export default function WormCounterApp() {
  const [file, setFile] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);

  const resetApp = () => {
    setFile(null);
    setResult(null);
    setError(null);
    setVideoPreview(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
      <div className="max-w-4xl mx-auto">
        <Header />

        <UploadSection
          file={file}
          setFile={setFile}
          processing={processing}
          setProcessing={setProcessing}
          setResult={setResult}
          setError={setError}
          setVideoPreview={setVideoPreview}
          videoPreview={videoPreview}
          resetApp={resetApp}
        />

        <ErrorAlert error={error} />

        <ResultsSection
          result={result}
          resetApp={resetApp}
        />

        <Footer />
      </div>
    </div>
  );
}